import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "nav-container"
};
const _hoisted_2 = {
  class: "nav-box"
};
const _hoisted_3 = {
  class: "nav-title"
};
const _hoisted_4 = {
  class: "submenu-title"
};
const _hoisted_5 = {
  class: "menu-item-text text-ellipsis"
};
const _hoisted_6 = {
  class: "nav-box-mobile"
};
const _hoisted_7 = {
  class: "nav-title"
};
const _hoisted_8 = {
  class: "submenu-title"
};
const _hoisted_9 = {
  class: "menu-item-text text-ellipsis"
};
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import { ElMessage } from 'element-plus';
import throttle from 'lodash/throttle';
import { categoryList } from '@/utils/info';
export default /*@__PURE__*/_defineComponent({
  __name: 'Category',
  setup(__props) {
    const router = useRouter();
    const activeIndex = ref('/');
    const userStore = useUserStore();
    const navList = [{
      name: '课件',
      route: 'Courses',
      hasCategory: true,
      keshiList: categoryList
    }, {
      name: '微课',
      route: 'Courseware',
      hasCategory: true,
      keshiList: categoryList
    }, {
      name: '图库',
      route: 'Images',
      hasCategory: true,
      keshiList: categoryList
    }, {
      name: '图像后处理工作站操作说明',
      route: 'Instructions',
      hasCategory: false,
      keshiList: ['图像后处理工作站操作说明']
    }, {
      name: '资源',
      route: 'Resources',
      hasCategory: true,
      keshiList: ['广州医科大学附属第一医院官方网站', '中国医科大学图书馆', '丁香园', '医脉通', '华医网']
    }];
    // 处理菜单栏点击情况
    const handleCaidanClick = (leimu, keshi) => {
      router.push({
        name: leimu,
        query: {
          category: keshi
        }
      });
    };
    // 处理点击上传按钮的回调
    const upload = throttle(() => {
      if (!userStore.isLoggedIn) {
        ElMessage.warning('管理员登录后才能上传');
        return;
      }
      router.push({
        name: 'Upload'
      });
    }, 500);
    return (_ctx, _cache) => {
      const _component_location = _resolveComponent("location");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_Upload = _resolveComponent("Upload");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_menu, {
        mode: "horizontal",
        router: true,
        class: "animated-menu",
        "background-color": "#ffffff",
        "active-text-color": "#409EFF",
        "text-color": "#2c3e50",
        "default-active": activeIndex.value,
        ellipsis: false
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navList, (item, index) => {
          return _createVNode(_component_el_sub_menu, {
            key: index,
            index: item.route,
            "popper-class": "custom-submenu"
          }, {
            title: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.keshiList, subItem => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: subItem,
                class: "nav-subitem",
                index: `${item.route}-${subItem}`,
                onClick: $event => handleCaidanClick(item.route, subItem)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_location)]),
                  _: 1
                }), _createElementVNode("span", _hoisted_5, _toDisplayString(subItem), 1)]),
                _: 2
              }, 1032, ["index", "onClick"]);
            }), 128))]),
            _: 2
          }, 1032, ["index"]);
        }), 64))]),
        _: 1
      }, 8, ["default-active"]), _createElementVNode("div", {
        class: "upload-button",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _unref(upload) && _unref(upload)(...args))
      }, [_createVNode(_component_el_button, {
        type: "primary",
        class: "upload-btn"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Upload)]),
          _: 1
        }), _cache[2] || (_cache[2] = _createTextVNode(" 上传资源 "))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_menu, {
        mode: "vertical",
        router: true,
        class: "animated-menu-mobile",
        "background-color": "#ffffff",
        "active-text-color": "#409EFF",
        "text-color": "#2c3e50",
        "default-active": activeIndex.value,
        ellipsis: false
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navList, (item, index) => {
          return _createVNode(_component_el_sub_menu, {
            key: index,
            index: item.route,
            "popper-class": "custom-submenu"
          }, {
            title: _withCtx(() => [_createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.keshiList, subItem => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: subItem,
                class: "nav-subitem",
                index: `${item.route}-${subItem}`,
                onClick: $event => handleCaidanClick(item.route, subItem)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_location)]),
                  _: 1
                }), _createElementVNode("span", _hoisted_9, _toDisplayString(subItem), 1)]),
                _: 2
              }, 1032, ["index", "onClick"]);
            }), 128))]),
            _: 2
          }, 1032, ["index"]);
        }), 64))]),
        _: 1
      }, 8, ["default-active"]), _createElementVNode("div", {
        class: "upload-button",
        onClick: _cache[1] || (_cache[1] =
        //@ts-ignore
        (...args) => _unref(upload) && _unref(upload)(...args))
      }, [_createVNode(_component_el_button, {
        type: "primary",
        class: "upload-btn"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Upload)]),
          _: 1
        }), _cache[3] || (_cache[3] = _createTextVNode(" 上传资源 "))]),
        _: 1
      })])])]);
    };
  }
});